export default "__VITE_ASSET__e4d3097d__"